<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>客户</h4>
        <span class="f-s-14 c-m-l-15">管理个人客户和公司客户</span>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入姓名/手机/地址/产品"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button v-if="state != 'archived'" type="primary" @click="doNew" class="c-m-l-10">
          新建客户
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            //osg.export('contacts', {
            // 'regex:name|string#or': searchValue,
            // 'regex:phone|string#or': searchValue,
            // 'regex:email|string#or': searchValue
            //})
            osg.doExport(
              {
                'in:state|integer#and': state == 'archived' ? -1 : 1,
                'regex:name|string#or': searchValue,
                'regex:phone|string#or': searchValue,
                'regex:email|string#or': searchValue,
                'ne:name|string#and': '中继号呼叫客户',
                'regex:address|string#or': searchValue,
                'regex:exts.newAddress|string#or': searchValue,
                'regex:exts.purchaseStr|string#or': searchValue,
                'all:exts.contactsPhone|array#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'contacts',
                title: '客户列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh && extFields.length"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('Contacts,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Contacts,conver')"
                    @click.native="doConver(scope.row)"
                  >
                    转为工单
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Contacts,able') && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Contacts,able') && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Contacts,archive') && state != 'archived'"
                    @click.native="doArchive(scope.row, '归档')"
                  >
                    归档
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('Contacts?state=archived,recover') && state == 'archived'"
                    @click.native="doArchive(scope.row, '恢复')"
                  >
                    恢复
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields">
            <template slot="name">
              <el-table-column label="姓名" width="120" fixed show-overflow-tooltip prop="name">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="$router.push({ path: `/contact/${scope.row._id}` })"
                    type="text"
                  >
                    {{ scope.row.name }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="外呼"
                width="55"
                fixed
                v-if="tenantId != '1340835581184723420' && serviceState"
              >
                <template slot-scope="scope">
                  <el-popconfirm
                    confirmButtonText="呼出"
                    cancelButtonText="取消"
                    icon="el-icon-phone"
                    iconColor="#409EFF"
                    hideIcon
                    :title="scope.row.name + ' ' + scope.row.phone"
                    @confirm="callOut(scope.row)"
                    popper-class="c-popconfirm"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-phone"
                      circle
                      slot="reference"
                    ></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="新增客户"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
      >
        <!-- <template slot="address">
          <el-input
            v-model="formData.address"
            suffix-icon="el-icon-map-location"
            @blur="osg.getGeocode()"
          ></el-input>
        </template> -->
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="转为工单"
      :visible.sync="openDetailSA"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="formDataSA"
        :rules="rules"
        ref="formDataSA"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="工单标题" prop="title">
          <el-input v-model="formDataSA.title"></el-input>
        </el-form-item>
        <el-form-item label="客户姓名" prop="title">
          <el-input v-model="formDataSA.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户姓名" prop="name">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="formDataSA.name"
            :fetch-suggestions="querySearch"
            placeholder="请输客户名称"
            @select="handleSelect"
            hide-loading
            value-key="name"
          >
            <i class="el-icon-search el-input__icon" slot="suffix"></i>
            <template slot-scope="{ item }">
              <p class="c-flex c-flex-between">
                <span>{{ item.name }}</span>
                <span>{{ item.phone }}</span>
              </p>
            </template>
          </el-autocomplete>
        </el-form-item> -->
        <el-form-item label="客户手机" prop="phone">
          <el-input v-model="formDataSA.phone"></el-input>
        </el-form-item>
        <el-form-item
          label="省市区"
          prop="area"
          :rules="{
            required: true,
            type: 'array',
            trigger: 'blur',
            message: '省市区不能为空'
          }"
        >
          <el-cascader
            popper-class="cascaderLabelHide-wrapper"
            ref="areaSelectorSA"
            :options="area.options"
            :props="area.props"
            v-model="formDataSA.area"
            clearable
            @change="
              if (formDataSA.subdistrict) {
                formDataSA.subdistrict = '';
              }
              osg.getSubdistricts(formDataSA.area, result => {
                options.subdistricts = result;
                this.$forceUpdate();
              });
            "
          ></el-cascader>
        </el-form-item>
        <el-form-item label="街道" prop="subdistrict">
          <el-select v-model="formDataSA.subdistrict">
            <el-option
              v-for="item in options.subdistricts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区" prop="community">
          <el-input v-model="formDataSA.community"></el-input>
        </el-form-item>
        <el-form-item
          label="详细地址"
          prop="address"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '详细地址不能为空'
          }"
        >
          <el-input v-model="formDataSA.address" @blur="osg.getGeocode()"></el-input>
        </el-form-item>
        <!-- <el-form-item label="经度" v-show="false">
          <el-input
            v-model="formDataSA.gpsPoint.longitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="纬度" v-show="false">
          <el-input
            v-model="formDataSA.gpsPoint.latitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          label="信息渠道"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '信息渠道不能为空'
          }"
        >
          <el-cascader
            clearable
            v-model="formDataSA.channel"
            :options="options.channel"
            :props="{ label: 'name' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="工作类型">
          <el-select v-model="formDataSA.workType">
            <el-option
              v-for="item in options.workType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-date-picker
            v-model="formDataSA.applyTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="优先级">
          <el-radio-group v-model="formDataSA.priority" @change="$forceUpdate()">
            <el-radio v-for="item of options.priority" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="阶段">
          <el-select v-model="formDataSA.stage">
            <el-option
              v-for="item in options.stage"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formDataSA.status">
            <el-option
              v-for="item in options.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="describe">
          <el-input type="textarea" :rows="1" v-model="formDataSA.describe"></el-input>
        </el-form-item>
        <!-- <el-form-item label="推广码" prop="promoteCode">
          <el-input v-model="formDataSA.promoteCode"></el-input>
        </el-form-item> -->
        <template v-if="extFieldsSA && extFieldsSA.length">
          <el-form-item
            v-for="(extField, idx) in extFieldsSA"
            :key="idx"
            :label="extField.nameDisp"
          >
            <template
              v-if="
                extField.type == 'text' ||
                  extField.type == 'textarea' ||
                  extField.type == 'number' ||
                  extField.type == 'phone'
              "
            >
              <el-input v-model="formDataSA.exts[extField.name]" :type="extField.type"></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model.number="formDataSA.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group v-model="formDataSA.exts[extField.name]" @change="$forceUpdate()">
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select v-model="formDataSA.exts[extField.name]" placeholder="请选择" clearable>
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'cascade'">
              <el-cascader
                clearable
                v-model="formDataSA.exts[extField.name]"
                :options="options[extField.valueOption]"
                :props="{ checkStrictly: true, label: 'name' }"
                @change="$forceUpdate()"
              ></el-cascader>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="formDataSA.exts[extField.name]"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'date' || extField.type == 'datetime'">
              <el-date-picker
                v-model="formDataSA.exts[extField.name]"
                :type="extField.type"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="formDataSA.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate
                v-model.number="formDataSA.exts[extField.name]"
                @change="$forceUpdate()"
              ></el-rate>
            </template>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSaveSA">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
export default {
  name: 'contacts',
  props: {
    serviceState: {
      type: String
    }
  },
  data() {
    return {
      tenantId: '',
      name: 'contacts',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' }
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      formDataSA: { exts: {} }, //工单表单
      openDetailSA: false, //工单弹窗
      extFieldsSA: [], //工单扩展
      state: '', //已归档 archived
      refresh: true //表格刷新
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    let account = JSON.parse(sessionStorage['loginAccount'] || sessionStorage['entity']);
    this.tenantId = account.tenantId;
    await this.getExtFieldsSA();
    this.osg.getFields('contacts', () => {
      this.osg.codeoption(() => {
        this.osg.getFpi();
        this.getData();
      });
    });
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProvince(row, column, cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(row, column, cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(row, column, cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatLeadStatus(row, column, cellValue) {
      return this.osg.codelabel('leadStatus', cellValue);
    },
    formatLifecycleStage(row, column, cellValue) {
      return this.osg.codelabel('lifecycleStage', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.state = this.osg.param('state');
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': this.state == 'archived' ? -1 : 1,
        'regex:name|string#or': this.searchValue,
        'ne:name|string#and': '中继号呼叫客户',
        'regex:phone|string#or': this.searchValue,
        'regex:email|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'regex:exts.newAddress|string#or': this.searchValue,
        'regex:exts.purchaseStr|string#or': this.searchValue,
        'all:exts.contactsPhone|array#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/contacts/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.osg.getSubdistricts(this.formData.area, result => {
        this.options.subdistricts = result;
        this.$forceUpdate();
      });
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        // 赋值省市区
        this.formData.area = this.formData.area || [];
        this.formData.province = this.formData.area[0] || '';
        this.formData.city = this.formData.area[1] || '';
        this.formData.district = this.formData.area[2] || '';
        //存经纬度用.的key来存值
        if (this.formData.gpsPoint) {
          this.$set(this.formData, 'gpsPoint.longitude', this.formData.gpsPoint.longitude);
          this.$set(this.formData, 'gpsPoint.latitude', this.formData.gpsPoint.latitude);
          delete this.formData.gpsPoint;
        }
        this.osg.ajax(
          'basic/contacts/upsertJson.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    //转工单操作按钮
    doConver(row) {
      row = this.$util.deepCopy(row);
      this.openDetailSA = true;
      this.formDataSA = {
        contactIds: [row._id],
        name: row.name,
        address: row.address,
        area: row.area,
        belongTo: row.belongTo,
        province: row.province,
        city: row.city,
        district: row.district,
        phone: row.phone,
        exts: {}
      };
    },
    doSaveSA() {
      if (this.osg.validate('formDataSA')) {
        var params = this.formDataSA;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
            }
          }
        }
        // delete params.area;
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.doInit();
            this.getData();
            // this.osg.confirm('保存成功！需要跳转到工单吗？', () => {
            //   this.$router.push({ path: '/ServiceAppointments' });
            // });
            this.osg.toast('操作成功！');
          }
        );
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/contacts/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/contacts/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doArchive(row, msg) {
      this.osg.confirm(`是否确认${msg}客户 ${row.name}？`, () => {
        this.osg.ajax('basic/contacts/archive/' + row._id + '.do', null, () => {
          this.getData();
          this.osg.toast(`已${msg}客户 ${row.name}`);
        });
      });
    },
    getExtFieldsSA() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'serviceAppointment',
          _all: '1',
          'is:state|integer#and': 1,
          'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsSA = res.data;
          this.options = this.options || [];
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
        },
        { noload: true }
      );
    },
    /**
     * 外呼
     */
    callOut(row) {
      this.$router.push({
        name: 'contact',
        params: { id: row._id, isCall: true }
      });

      // 调用外呼接口-传外呼号码
      // this.osg.sobot.callOut({
      //   destinationNumber: row.phone,
      //   params: `{ "bizType": "Contacts", "bizId":"${row._id}"}`
      // });
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.doInit();
      this.osg.getFpi();
      this.getData();
    },
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'formDataSA.area'() {
      if (this.$refs.areaSelectorSA) {
        this.$refs.areaSelectorSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //信息渠道,级联组件点击label就消失
    'formData.channel'() {
      if (this.$refs.channelCascader) {
        this.$refs.channelCascader.dropDownVisible = false; //监听值发生变化就关闭它
      }
    }
  }
};
</script>
